import React from 'react';
import InputMask from 'react-input-mask';

const Input = ({
  name,
  label,
  value = '',
  type = 'text',
  handleOnChange,
  required = false,
  hasError,
  errorMessage,
  disabled,
  onKeyUp,
  pattern,
}) => {
  if (type === 'tel') {
    return (
      <div className="input-wrap">
        <label htmlFor={name}>
          {label} {required && '*'}
        </label>
        <InputMask
          name={name}
          id={name}
          className={['form-control', hasError].join(' ')}
          type={type}
          value={value}
          onChange={handleOnChange}
          required={required}
          mask="999-999-9999"
          maskChar={null}
          pattern="^[2-9]\d{2}-\d{3}-\d{4}$"
          disabled={disabled}
          onKeyUp={onKeyUp}
        />
        <div className="invalid-feedback">
          {errorMessage
            ? errorMessage[0]
            : `Please enter a valid ${label.toString().toLowerCase()}`}
        </div>
      </div>
    );
  }
  return (
    <div className="input-wrap">
      <label htmlFor={name}>
        {label} {required && '*'}
      </label>
      <input
        name={name}
        id={name}
        className={['form-control', hasError].join(' ')}
        type={type}
        value={value}
        onChange={handleOnChange}
        required={required}
        disabled={disabled}
        onKeyUp={onKeyUp}
        pattern={pattern || undefined}
      />
      <div className="invalid-feedback">
        {errorMessage
          ? errorMessage[0]
          : `Please enter a valid ${label.toString().toLowerCase()}`}
      </div>
    </div>
  );
};

export default Input;
